// Gruntfile.js uses string-replace-loader to replace these values during build time.
export const VERSION = '5.0.0-alpha.11';
export const ID = 'c69cac551a93c40ca493575600bc0c01d2c3ff90';
export const DATE = '2023-11-03T23:02:47.029Z';
